import React from 'react';
import './Home.css';
import { NavBar } from '../NavBar/NavBar';
import logo from '../../assets/logomondwild.png'
import foto from '../../assets/foto_4_mobile.jpg';

import { NavBarMobile } from '../NavBar/NavBarMobile';


export const HomeMobile = () => {
	return (
		<>
		{/* <section id='home'>	 */}
		<div className='logo-links-mobile'>
			
		<img style={{width: '200px'}}
                             src={logo}
                        /> 
						

			
		<NavBarMobile/>

		<div className='text-card-container'>

                <div className="row">
                    <div className="col-sm-12">

		<img style={{width: '100%'}}
	
                             src={foto}
                        /> 
			
			</div>
			</div>
			</div>
			</div>
			
		{/* </section> */}
		</>
	);
}